import { CONFERENCE_ZONE_TYPE_ID } from "../../../../../features/Booking-Form/typings/place-and-zone-type-ids.constant";
import { ZoneVariant } from "../../../Domain/Types/FloorPlan/ZoneVariant.type";
import { colorPerType } from "./colorPerType.function";

export function resolveZonePolygonFillColor({
  zoneType,
  variant,
  isSelected,
  disabled,
  selectedFillColor,
  isReferenceHighlighted,
  referenceFillColor,
  colorOverride,
  vividStandard
}: {
  zoneType: number;
  variant: ZoneVariant | undefined;
  isSelected: boolean;
  disabled?: boolean;
  selectedFillColor?: number;
  isReferenceHighlighted?: boolean;
  referenceFillColor?: number;
  colorOverride?: number;
  /** Create-plan editor: original standard-zone green. Booking stays muted. */
  vividStandard?: boolean;
}): number {
  if (isSelected && selectedFillColor != null) {
    return selectedFillColor;
  }
  if (isReferenceHighlighted && referenceFillColor != null) {
    return referenceFillColor;
  }
  if (
    colorOverride != null &&
    !isSelected &&
    !disabled &&
    variant !== ZoneVariant.OCCUPIED &&
    variant !== ZoneVariant.BLOCKED &&
    variant !== ZoneVariant.FORBIDDEN &&
    variant !== ZoneVariant.DISABLED
  ) {
    return colorOverride;
  }
  return fillColorByVariant(zoneType, variant, isSelected, disabled, vividStandard);
}

/** Booking available place zones: no type tint. Disabled stays grey. */
const BOOKING_AVAILABLE_PLACE_ZONE_FILL = 0xf2f2f2;

export const fillColorByVariant = (
  zoneType: number,
  variant: ZoneVariant | undefined,
  isSelected: boolean,
  disabled?: boolean,
  vividStandard?: boolean
): number => {
  const selectedColor = 0x0000ff;
  const disabledColor = 0x5e5e5e;
  const occupiedColor = 0xff0000;
  const forbiddenColor = 0xd2dae1;
  const tempColor = 0xdddd56;

  if (isSelected) return selectedColor;
  if (disabled) return disabledColor;
  if (!variant) return colorPerType(zoneType, { vividStandard });

  switch (variant) {
    case ZoneVariant.AVAILABLE:
      if (zoneType === CONFERENCE_ZONE_TYPE_ID) {
        return colorPerType(zoneType, { vividStandard });
      }
      return BOOKING_AVAILABLE_PLACE_ZONE_FILL;
    case ZoneVariant.OCCUPIED:
      return occupiedColor;
    case ZoneVariant.BLOCKED:
      // Green base; slash mark is drawn at zone center separately.
      return 0x28b869;
    case ZoneVariant.DISABLED:
      return disabledColor;
    case ZoneVariant.FORBIDDEN:
      return forbiddenColor;
    case ZoneVariant.TEMP:
      return tempColor;
    default:
      return colorPerType(zoneType, { vividStandard });
  }
};
